import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Shared toolbar entry for the Table Options panel: a tune-icon button
 * (options-2-outline) with an active-filter count badge. Each host wires its own
 * opener via (open) and feeds the badge via [count], absorbing the per-table
 * variance: e.g. an `events.next(DualAxisEvent.OPENFILTERS)` emit or a direct
 * `dualAxis.openOptions('filters')` call — all converge on the same panel. Reuses the
 * global .toolbar-funnel / .funnel-badge styles in styles.scss.
 */
@Component({
  selector: 'bst-table-options-button',
  template: `
    <button nbButton ghost status="basic" size="small" type="button"
            class="toolbar-funnel"
            (click)="open.emit()"
            [nbTooltip]="'options' | translate" [attr.aria-label]="'options' | translate">
      <nb-icon icon="options-2-outline"></nb-icon>
      @if (count > 0) { <span class="funnel-badge">{{ count }}</span> }
    </button>
  `,
  styles: [':host { display: inline-flex; }'],
  standalone: false,
})
export class TableOptionsButtonComponent {
  @Input() count = 0;
  @Output() open = new EventEmitter<void>();
}
